import { Box, Skeleton } from '@mui/material';
import React from 'react';

export const MobileLoadingMenu = ({ dataTest }) => {
  return (
    <Box mx={3} data-test={dataTest}>
      <Skeleton animation="wave" variant="rectangular" sx={{ mb: 1, maxWidth: '50%' }} />
      <Skeleton animation="wave" variant="rectangular" sx={{ my: 1 }} />
      <Skeleton animation="wave" variant="rectangular" sx={{ my: 1 }} />
      <Skeleton animation="wave" variant="rectangular" sx={{ my: 1, maxWidth: '50%' }} />
      <Skeleton animation="wave" variant="rectangular" sx={{ my: 1 }} />
      <Skeleton animation="wave" variant="rectangular" sx={{ mt: 1 }} />
    </Box>
  );
};
